module.exports = __webpack_public_path__ + "5d8f467fa86eb0faa9a7466f5562af09.svg";


//////////////////
// WEBPACK FOOTER
// ./src/helpers/images/milestoneImage/background-purple.svg
// module id = ./src/helpers/images/milestoneImage/background-purple.svg
// module chunks = 5